'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.deck.gce.loadBalancer.details.healthCheck.component', [])
  .component('gceHealthCheck', {
    bindings: {
      healthCheck: '='
    },
    templateUrl: require('./healthCheck.component.html')
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/google/src/loadBalancer/details/healthCheck/healthCheck.component.js